import PropTypes from 'prop-types'

export const FREE_TRIAL_TYPE = PropTypes.shape({
  id: PropTypes.string,
  durationDays: PropTypes.number,
  eligible: PropTypes.bool,
  advocate: PropTypes.shape({
    email: PropTypes.string,
    id: PropTypes.number,
    name: PropTypes.string,
    profileImg: PropTypes.string,
  }),
  source: PropTypes.shape({
    name: PropTypes.string,
    promoCode: PropTypes.string,
    sharedContent: PropTypes.any,
  }),
})
